
import React, { memo } from 'react';
import MediaQuery from 'react-responsive';
import { Button, LabelWrapper } from '../../../ui-kit';
import Files from '../../Files';
import LinkSocialButton from './LinkSocialButton';

import '../styles/_social-profiles-content.scss';


const SMALL_BREAKPOINT = 565;












function SocialProfilesContent(
{
  socialProfiles,
  onSave,
  allowedSocialTypes,
  modalTitle,
  modalDescription,
  buttonTitle,
  onSelectImage,
  disabled
})
{
  return (
    <>
      <div
        className="social-profiles-content"
        key="image-upload">

        {
        !disabled ?

        <LabelWrapper label="Edit Profile Image">
                <Files
            onFilesChange={onSelectImage}
            allowedTypes={['image']}
            minFileSize={0}
            clickable>

                  <Button type="TERTIARY">Browse Files</Button>
                </Files>
              </LabelWrapper> :

        null}

        <MediaQuery maxWidth={SMALL_BREAKPOINT}>
          <LinkSocialButton
            socialProfiles={socialProfiles}
            allowedSocialTypes={allowedSocialTypes}
            onSave={onSave}
            hideLabel
            disabled={disabled} />

        </MediaQuery>
      </div>
      <MediaQuery minWidth={SMALL_BREAKPOINT + 1} key="link-social-btn">
        <LinkSocialButton
          socialProfiles={socialProfiles}
          onSave={onSave}
          modalTitle={modalTitle}
          modalDescription={modalDescription}
          buttonTitle={buttonTitle}
          allowedSocialTypes={allowedSocialTypes}
          disabled={disabled} />

      </MediaQuery>
    </>);

}

export default memo(SocialProfilesContent);